import React from 'react';
import { Typography, IconButton, Divider, Theme, Close as CloseIcon, makeStyles } from '@quillbot/design-system';
import { useDispatch, useSelector } from 'react-redux';
import { toggleDrawerAction } from 'src/_common/actions/commonActions';
import { RootState } from 'src/_common/models/redux/store';

const useStyles = makeStyles((theme: Theme) => ({
  title: {
    fontSize: '17px',
    fontWeight: 'bold',
  },
  root: {
    '&:hover': {
      backgroundColor: 'inherit',
    },
  },
}));

function DrawerHeader(props: { name: string; controls?: React.ComponentType<any> }) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const quillDrawer = useSelector((state: RootState) => state?.common?.quillDrawer);
  const isOpencompareModeDrawer = useSelector((state: RootState) => state?.common?.isOpencompareModeDrawer);

  return (
    <div>
      {props.controls && quillDrawer !== 'PPHR_STATISTICS' && !isOpencompareModeDrawer ? (
        <>
          <props.controls
            direction="row"
            controlBarContainer={{
              left: 0,
              marginRight: 40,
              top: '-8px',
            }}
            controlBarGrid={{
              justifyContent: quillDrawer === null || quillDrawer === undefined ? 'space-around' : 'flex-start',
            }}
            tooltipPlacement="top"
          />
          <Divider
            style={{
              width: 'calc(100% + 30px)',
              margin: 'auto -15px',
            }}
          />
          {props.name && (
            <div style={{ marginTop: '15px' }}>
              <Typography
                variant="caption"
                className={classes.title}
                // style={{
                //   fontSize: '17px',
                //   fontWeight: 'bold',
                //   color: '#5F6368',
                // }}
              >
                {props.name}
              </Typography>
            </div>
          )}
        </>
      ) : (
        <div>
          <Typography
            variant="caption"
            style={{
              fontSize: '1.5em',
              fontWeight: 600,
              paddingBottom: '10px',
            }}>
            {props.name}
          </Typography>
          <Divider
            style={{
              width: 'calc(100% + 30px)',
              margin: 'auto -15px',
              position: 'relative',
              top: '3px',
            }}
          />
        </div>
      )}
      <IconButton
        classes={classes}
        onClick={() => {
          dispatch(toggleDrawerAction(null));
        }}
        style={{ position: 'absolute', right: 0, top: 2 }}
        size="large">
        <CloseIcon />
      </IconButton>
    </div>
  );
}

export default DrawerHeader;
